import { filter, takeUntil } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SimpleFieldConfig } from '../../simple-field.interface';
import { Subject } from 'rxjs';

@Component({
  selector: 'calsoft-input-lead',
  templateUrl: './input-lead.component.html',
  styleUrls: ['./input-lead.component.scss']
})
export class InputLeadComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';

  field: SimpleFieldConfig;
  group: UntypedFormGroup;
  display: boolean=false;
  formType: any;
  ngOnInit() {

    console.log(this.formType);
    

    if(this.group!=undefined){
      this.display=true;
    }
    
  }

  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    constructor(private router: Router) {
        this.url = this.router.url || '';
            this.router.events
              .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
              .subscribe(() => { this.url = this.router.url || ''; });
    }
}

